import type { JdxPayloadSchema } from "./types";

export const jdxCargoPayloadSchema: JdxPayloadSchema = {
  key: "patch-cargo",
  label: "JDX Cargo Payload",
  description:
    "Payload voor het bijwerken van cargo-informatie zoals containers, packages, MRN, customs en commerciële waarden.",
  fields: [
    {
      path: "containers",
      label: "Containers",
      group: "Containers",
      type: "array",
      required: true,
      children: [
        { path: "containers[].id", label: "Container ID", group: "Containers", type: "string" },
        { path: "containers[].containerType.isoCode", label: "Container type", group: "Containers", type: "string", example: "22G0" },
        { path: "containers[].containerType.carrierOwned", label: "Carrier owned", group: "Containers", type: "boolean", example: true },
        { path: "containers[].number", label: "Containernummer", group: "Containers", type: "string", example: "ABCD1234567" },
        { path: "containers[].sealNumber", label: "Sealnummer", group: "Containers", type: "string" },
        { path: "containers[].gross", label: "Brutogewicht", group: "Containers", type: "number" },
        { path: "containers[].net", label: "Nettogewicht", group: "Containers", type: "number" },
        { path: "containers[].volume", label: "Volume", group: "Containers", type: "number" },
        { path: "containers[].currency", label: "Valuta", group: "Containers", type: "string", example: "EUR" },
        { path: "containers[].commercialValue", label: "Commerciële waarde", group: "Containers", type: "number" },
        { path: "containers[].goodsDescription", label: "Goederenomschrijving", group: "Containers", type: "string" },
        { path: "containers[].marksAndNumbers", label: "Marks & numbers", group: "Containers", type: "string" },
        { path: "containers[].mrn", label: "MRN nummers", group: "Containers", type: "array", example: ["MRN1", "MRN2"] },
        {
          path: "containers[].packages",
          label: "Packages",
          group: "Packages",
          type: "array",
          children: [
            { path: "containers[].packages[].id", label: "Package ID", group: "Packages", type: "string" },
            { path: "containers[].packages[].quantity", label: "Aantal", group: "Packages", type: "number" },
            { path: "containers[].packages[].packageType", label: "Package type", group: "Packages", type: "string", example: "BOX" },
            { path: "containers[].packages[].lengthCm", label: "Lengte cm", group: "Packages", type: "number" },
            { path: "containers[].packages[].widthCm", label: "Breedte cm", group: "Packages", type: "number" },
            { path: "containers[].packages[].heightCm", label: "Hoogte cm", group: "Packages", type: "number" },
            { path: "containers[].packages[].volume", label: "Volume", group: "Packages", type: "number" },
            { path: "containers[].packages[].weight", label: "Gewicht", group: "Packages", type: "number" },
            { path: "containers[].packages[].net", label: "Nettogewicht", group: "Packages", type: "number" },
            { path: "containers[].packages[].goodsDescription", label: "Goederenomschrijving", group: "Packages", type: "string" },
            { path: "containers[].packages[].currency", label: "Valuta", group: "Packages", type: "string", example: "EUR" },
            { path: "containers[].packages[].commercialValue", label: "Commerciële waarde", group: "Packages", type: "number" },
            { path: "containers[].packages[].stackable", label: "Stapelbaar", group: "Packages", type: "boolean" },
            { path: "containers[].packages[].orderNumbers", label: "Ordernummers", group: "Packages", type: "array" },
            { path: "containers[].packages[].hsCodes", label: "HS-codes", group: "Packages", type: "array" },
            { path: "containers[].packages[].customsReference", label: "Customs references", group: "Packages", type: "array" },
            { path: "containers[].packages[].mrn", label: "MRN nummers", group: "Packages", type: "array" },
          ],
        },
      ],
    },
  ],
};